import { createAction } from 'redux-actions';
import { createRoutine } from 'redux-saga-routines';
import {
  RESET_STATIONS,
  SET_SELECTED_STATION,
  SET_STATIONS,
  SET_VIDEO,
  SET_VISITED_STATION,
  VISIT_ALL_STATIONS,
  RESET_VISITED_STATUS_ALL_STATIONS,
} from './type';

export const setVideo = createRoutine(SET_VIDEO);

export const setSelectedStation = createAction(SET_SELECTED_STATION);
export const setStations = createAction(SET_STATIONS);
export const resetStations = createAction(RESET_STATIONS);
export const setVisitedStation = createAction(SET_VISITED_STATION);
export const visitAllStations = createAction(VISIT_ALL_STATIONS);
export const resetVisitedStatusAllStations = createAction(
  RESET_VISITED_STATUS_ALL_STATIONS
);
